import { zodResolver } from '@hookform/resolvers/zod';
import { ReactNode } from 'react';
import { FormProvider, SubmitHandler, useForm, UseFormProps } from 'react-hook-form';
import { z, ZodTypeAny } from 'zod';

interface FormProps<TSchema extends ZodTypeAny> {
  defaultValues?: UseFormProps<z.infer<TSchema>>['defaultValues'];
  onSubmit: SubmitHandler<z.infer<TSchema>>;
  children: ReactNode;
  schema: TSchema;
  formClassName?: string;
}

function GenericForm<TSchema extends ZodTypeAny>({
  defaultValues,
  onSubmit,
  children,
  schema,
  formClassName,
}: FormProps<TSchema>) {
  const methods = useForm<z.infer<TSchema>>({
    defaultValues,
    resolver: zodResolver(schema),
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} className={formClassName}>
        {children}
      </form>
    </FormProvider>
  );
}

export default GenericForm;
